const API_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/api'
    : 'https://www.tvant.org/api';

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: `${API_BASE_URL}/auth/register`,
    LOGIN: `${API_BASE_URL}/auth/login`,
    ME: `${API_BASE_URL}/auth/me`,
    CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`
  },
  ORDERS: {
    CREATE: `${API_BASE_URL}/orders`,
    LIST: `${API_BASE_URL}/orders`,
    DETAIL: (id) => `${API_BASE_URL}/orders/${id}`,
    MY: `${API_BASE_URL}/orders/my`,
    BASE: `${API_BASE_URL}/orders`,
    GET_ORDER: `${API_BASE_URL}/orders`,
    PAY: (orderId) => `${API_BASE_URL}/orders/${orderId}/pay`,
    USDT_STATUS: (orderId) => `${API_BASE_URL}/orders/${orderId}/usdt-status`
  }
};

export const fetchWithCredentials = async (url, options = {}) => {
  console.log('fetchWithCredentials called with url:', url);
  // 从localStorage获取token
  const token = localStorage.getItem('token');
  console.log('Current token:', token); // 添加token日志
  
  // 确保 options.headers 存在
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'x-auth-token': token } : {}), // 如果有token就添加到请求头
    ...(options.headers || {})
  };

  const defaultOptions = {
    credentials: 'include',
    headers
  };

  // 合并选项，确保 headers 正确设置
  const finalOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers
    }
  };

  console.log('Request options:', {
    url,
    method: finalOptions.method,
    headers: finalOptions.headers,
    body: finalOptions.body
  });

  try {
    const response = await fetch(url, finalOptions);
    console.log('Response status:', response.status); // 添加响应状态日志
    
    if (response.status === 401) {
      // Token过期或无效，清除本地存储并重定向到登录页面
      console.log('Token expired or invalid, redirecting to login');
      localStorage.removeItem('token');
      window.location.href = '/auth';
      throw new Error('登录已过期，请重新登录');
    }
    
    if (!response.ok) {
      let errorText = await response.text();
      let error;
      try {
        error = JSON.parse(errorText);
      } catch {
        error = { message: errorText };
      }
      console.error('API Error:', error); // 添加错误日志
      throw new Error(error.message || '请求失败');
    }

    // 先尝试text，再尝试JSON
    const dataText = await response.text();
    let data;
    try {
      data = JSON.parse(dataText);
    } catch (e) {
      console.error('返回内容不是JSON:', dataText);
      throw new Error('API未返回JSON');
    }
    console.log('Response data:', data); // 添加响应数据日志
    return data;
  } catch (error) {
    console.error('Fetch error:', error); // 添加捕获错误日志
    throw error;
  }
};

export default API_BASE_URL; 